<template>
  <div class="approval-flow-page">
    <basic-container>
      <el-card shadow="never" class="flow-card">
        <div slot="header" class="card-header">
          <span class="card-title">审批流程配置</span>
          <div class="card-header-right">
            <el-button size="small" icon="el-icon-refresh" @click="handleLoad">刷 新</el-button>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-check"
              :loading="saving"
              @click="handleSave"
            >
              保存配置
            </el-button>
          </div>
        </div>

        <!-- 配置定位：业务类型 + 作用范围 -->
        <div class="flow-target">
          <div class="target-item">
            <span class="target-label">业务类型</span>
            <el-select
              v-model="businessType"
              size="small"
              style="width: 200px"
              placeholder="请选择业务类型"
              @change="onTargetChange"
            >
              <el-option
                v-for="bt in businessTypes"
                :key="bt.typeCode"
                :label="bt.typeName"
                :value="bt.typeCode"
              />
            </el-select>
          </div>
          <div class="target-item">
            <span class="target-label">作用范围</span>
            <el-radio-group v-model="scopeType" size="small" @change="onScopeTypeChange">
              <el-radio-button label="default">组织默认流程</el-radio-button>
              <el-radio-button label="project">按项目类型</el-radio-button>
              <el-radio-button label="object">指定业务对象</el-radio-button>
            </el-radio-group>
            <el-select
              v-if="scopeType === 'object'"
              v-model="businessKey"
              filterable
              clearable
              size="small"
              style="width: 260px; margin-left: 12px"
              placeholder="选择价盘（业务对象）"
              @change="onTargetChange"
            >
              <el-option v-for="pb in priceBooks" :key="pb.id" :label="pb.name" :value="pb.id" />
            </el-select>
            <el-select
              v-if="scopeType === 'project'"
              v-model="businessKey"
              clearable
              size="small"
              style="width: 180px; margin-left: 12px"
              placeholder="选择项目类型"
              @change="onTargetChange"
            >
              <el-option
                v-for="item in projectTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>

        <!-- 当前编辑目标 -->
        <el-alert
          :title="targetDesc"
          type="success"
          :closable="false"
          show-icon
          class="target-alert"
        />

        <el-alert title="配置说明" type="info" :closable="false" show-icon class="target-alert">
          <div>1. 审批节点从上到下依次为第 1 级、第 2 级…，第 N 级全部通过后流转至第 N+1 级，可调整顺序。</div>
          <div>2. 提交审批时自动匹配：价盘专属流程 → 项目类型流程 → 组织默认流程 → 都没有则无法提交。配置按当前登录组织生效。</div>
          <div>3. 保存「按项目类型」只替换该项目类型流程（如吊顶/防水），不影响其他项目类型。</div>
          <div>4. 保存「指定业务对象」只替换该对象专属流程（如某价盘的审批人），不影响组织默认流程。</div>
        </el-alert>

        <!-- 审批节点列表 -->
        <el-table
          :data="nodes"
          border
          stripe
          v-loading="loading"
          empty-text="尚未配置审批节点，请点击下方“新增审批人”添加"
        >
          <el-table-column label="序号" width="70" align="center" type="index" :index="1" />
          <el-table-column label="节点级别" width="120" align="center">
            <template slot-scope="scope">第 {{ scope.$index + 1 }} 级</template>
          </el-table-column>
          <el-table-column prop="approverName" label="审批人" min-width="200" align="center" />
          <el-table-column label="操作" width="240" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-top"
                :disabled="scope.$index === 0"
                @click="moveNode(scope.$index, -1)"
              >
                上移
              </el-button>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-bottom"
                :disabled="scope.$index === nodes.length - 1"
                @click="moveNode(scope.$index, 1)"
              >
                下移
              </el-button>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click="removeNode(scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="add-row">
          <el-button size="small" type="primary" plain icon="el-icon-plus" @click="openChooseDialog">
            新增审批人
          </el-button>
        </div>
      </el-card>
    </basic-container>

    <!-- 选择审批人弹窗 -->
    <el-dialog
      title="选择审批人"
      :visible.sync="chooseDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @open="chooseKeyword = ''"
    >
      <el-input
        v-model="chooseKeyword"
        placeholder="输入姓名搜索"
        clearable
        prefix-icon="el-icon-search"
        style="margin-bottom: 12px"
      />
      <el-table
        :data="filteredStuffs"
        border
        size="small"
        max-height="360"
        highlight-current-row
        empty-text="暂无可用员工"
        @current-change="onChooseRowChange"
      >
        <el-table-column prop="name" label="姓名" min-width="140" />
        <el-table-column prop="deptName" label="部门" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.deptName || scope.row.departmentName || "-" }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="chooseDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="!selectedStuff" @click="confirmChoose">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findStuffAll } from "@/api/salesCloud/stuff";
import { findPriceBookPage } from "@/api/work/waterProof/merchantPrice";
import {
  findApprovalFlowList,
  saveApprovalFlow,
  findApprovalBusinessTypeList,
} from "@/api/work/waterProof/approval";

export default {
  name: "approvalFlow",
  data() {
    return {
      loading: false,
      saving: false,
      // 业务类型（来自审批业务类型菜单）
      businessTypes: [],
      businessType: "",
      // 作用范围：default=组织默认；project=项目类型；object=指定价盘
      scopeType: "default",
      previousScopeType: "default",
      // 业务标识：项目类型编码或价盘ID；空串=组织默认流程
      businessKey: "",
      priceBooks: [],
      projectTypes: [
        { label: "防水", value: "WATERPROOF" },
        { label: "回填", value: "BACKFILL" },
        { label: "吊顶", value: "HANG_CEILING" },
      ],
      // 当前已配置的审批节点（顺序即审批级别）
      nodes: [],
      // 最近一次加载/保存后的节点快照，用于未保存改动提示
      snapshot: "[]",
      stuffs: [],
      chooseDialogVisible: false,
      chooseKeyword: "",
      selectedStuff: null,
    };
  },
  computed: {
    // 过滤掉已配置的人 + 按关键字搜索
    filteredStuffs() {
      const usedIds = this.nodes.map((n) => String(n.approverId));
      const kw = (this.chooseKeyword || "").trim().toLowerCase();
      return (this.stuffs || []).filter((s) => {
        if (usedIds.includes(String(this.stuffId(s)))) return false;
        if (kw) return this.stuffName(s).toLowerCase().includes(kw);
        return true;
      });
    },
    // 当前编辑目标描述
    targetDesc() {
      if (!this.businessType) return "请先选择业务类型";
      const bt = this.businessTypes.find((b) => b.typeCode === this.businessType);
      const typeName = bt ? bt.typeName : this.businessType;
      if (this.scopeType === "default") {
        return `${typeName} · 组织默认流程（未配置专属流程的单据走此流程）`;
      }
      if (this.scopeType === "project") {
        if (!this.businessKey) {
          return `${typeName} · 项目类型流程（请选择项目类型）`;
        }
        const project = this.projectTypes.find((item) => item.value === this.businessKey);
        return `${typeName} · 项目类型流程：${project ? project.label : this.businessKey}`;
      }
      if (!this.businessKey) {
        return `${typeName} · 指定业务对象（请选择价盘）`;
      }
      const pb = this.priceBooks.find((p) => p.id === this.businessKey);
      return `${typeName} · 业务对象专属流程：${pb ? pb.name : this.businessKey}`;
    },
  },
  created() {
    this.loadBusinessTypes();
    this.loadPriceBooks();
  },
  methods: {
    parseData(res) {
      if (!res || res.data == null) return {};
      if (typeof res.data === "string") {
        try {
          return JSON.parse(res.data) || {};
        } catch (e) {
          console.log("parseData error:", e);
          return {};
        }
      }
      return res.data;
    },
    stuffId(s) {
      return s.id || s.userId || "";
    },
    stuffName(s) {
      return s.name || s.realName || s.username || String(this.stuffId(s));
    },
    // 节点是否有未保存的修改
    isDirty() {
      return JSON.stringify(this.nodes) !== this.snapshot;
    },
    // 加载业务类型菜单
    loadBusinessTypes() {
      findApprovalBusinessTypeList()
        .then((res) => {
          if (res.code === "200") {
            const data = this.parseData(res);
            const list = Array.isArray(data) ? data : data.rows || data.list || [];
            // 仅展示启用类型
            this.businessTypes = list.filter(
              (b) => !b.status || b.status === "ENABLE"
            );
            if (!this.businessType && this.businessTypes.length) {
              this.businessType = this.businessTypes[0].typeCode;
            }
            if (this.businessType) {
              this.handleLoad();
            } else {
              this.$message.warning("暂无可用业务类型，请先在“审批业务类型”菜单中配置");
            }
          } else {
            this.$message.error(res.message || "加载业务类型失败");
          }
        })
        .catch((err) => {
          console.log("findApprovalBusinessTypeList error:", err);
          this.$message.error("加载业务类型异常");
        });
    },
    // 加载价盘列表（用于"指定业务对象"）
    loadPriceBooks() {
      findPriceBookPage()
        .then((res) => {
          if (res.code === "200") {
            const data = this.parseData(res);
            this.priceBooks = Array.isArray(data)
              ? data
              : data.rows || data.list || [];
          }
        })
        .catch((err) => {
          console.log("findPriceBookPage error:", err);
        });
    },
    onScopeTypeChange() {
      // 切换作用范围后必须重新选择对应标识，避免把价盘ID误保存为项目类型或反之。
      // 先确认未保存修改，再清空旧标识，避免无提示丢失节点配置。
      const clearTarget = () => {
        this.businessKey = "";
        this.previousScopeType = this.scopeType;
        this.onTargetChange();
      };
      if (this.isDirty()) {
        this.$confirm(
          "当前修改尚未保存，切换作用范围后将丢失，确定继续吗？",
          "提示",
          { type: "warning" }
        )
          .then(clearTarget)
          .catch(() => {
            // 恢复单选按钮到切换前的值，避免界面选择与实际编辑目标不一致。
            this.scopeType = this.previousScopeType || "default";
          });
        return;
      }
      clearTarget();
    },
    // 业务类型 / 作用范围 / 业务对象 变更后重新加载
    onTargetChange() {
      if ((this.scopeType === "object" || this.scopeType === "project") && !this.businessKey) {
        this.nodes = [];
        this.snapshot = JSON.stringify(this.nodes);
        return;
      }
      if (this.isDirty()) {
        this.$confirm(
          "当前修改尚未保存，切换后将丢失，确定继续吗？",
          "提示",
          { type: "warning" }
        )
          .then(() => this.handleLoad())
          .catch(() => {});
        return;
      }
      this.handleLoad();
    },
    // 加载已配置流程（businessKey 空=组织默认流程）
    handleLoad() {
      if (!this.businessType) return;
      if ((this.scopeType === "object" || this.scopeType === "project") && !this.businessKey) {
        this.nodes = [];
        this.snapshot = JSON.stringify(this.nodes);
        return;
      }
      this.loading = true;
      findApprovalFlowList(this.businessType, this.businessKey)
        .then((res) => {
          if (res.code === "200") {
            const data = this.parseData(res);
            const list = Array.isArray(data)
              ? data
              : data.nodes || data.rows || data.list || [];
            this.nodes = list
              .map((n) => ({
                approverId: n.approverId || n.id || n.userId,
                approverName: n.approverName || n.name || "",
              }))
              .filter((n) => n.approverId || n.approverName);
            this.snapshot = JSON.stringify(this.nodes);
          } else {
            this.$message.error(res.message || "加载失败");
          }
        })
        .catch((err) => {
          console.log("findApprovalFlowList error:", err);
          this.$message.error("加载异常");
        })
        .finally(() => {
          this.loading = false;
        });
      this.loadStuffs();
    },
    loadStuffs() {
      findStuffAll()
        .then((res) => {
          if (res.code === "200") {
            const data = this.parseData(res);
            this.stuffs = Array.isArray(data) ? data : data.rows || data.list || [];
          }
        })
        .catch((err) => {
          console.log("findStuffAll error:", err);
        });
    },
    // 节点调整
    moveNode(index, offset) {
      const target = index + offset;
      if (target < 0 || target >= this.nodes.length) return;
      const arr = [...this.nodes];
      const [item] = arr.splice(index, 1);
      arr.splice(target, 0, item);
      this.nodes = arr;
    },
    removeNode(index) {
      this.$confirm("确定删除该审批节点吗？", "提示", { type: "warning" })
        .then(() => {
          this.nodes.splice(index, 1);
        })
        .catch(() => {});
    },
    // 选择审批人
    openChooseDialog() {
      this.selectedStuff = null;
      this.chooseDialogVisible = true;
    },
    onChooseRowChange(row) {
      this.selectedStuff = row;
    },
    confirmChoose() {
      if (!this.selectedStuff) {
        this.$message.warning("请先选择审批人");
        return;
      }
      this.nodes.push({
        approverId: this.stuffId(this.selectedStuff),
        approverName: this.stuffName(this.selectedStuff),
      });
      this.chooseDialogVisible = false;
      this.selectedStuff = null;
    },
    // 保存配置（整组替换 (businessType + 本组织 + businessKey)）
    handleSave() {
      if ((this.scopeType === "object" || this.scopeType === "project") && !this.businessKey) {
        this.$message.warning(this.scopeType === "project" ? "请先选择项目类型" : "请先选择业务对象（价盘）");
        return;
      }
      // 允许保存空节点：清除当前范围的专属流程，提交审批时自动降级匹配。
      this.doSave();
    },
    doSave() {
      this.saving = true;
      saveApprovalFlow({
        businessType: this.businessType,
        businessKey: this.businessKey,
        nodes: this.nodes.map((n) => ({
          approverId: n.approverId,
          approverName: n.approverName,
        })),
      })
        .then((res) => {
          if (res.code === "200") {
            this.snapshot = JSON.stringify(this.nodes);
            this.$message.success("保存成功，审批流程已生效");
          } else {
            this.$message.error(res.message || "保存失败");
          }
        })
        .catch((err) => {
          console.log("saveApprovalFlow error:", err);
          this.$message.error("保存异常");
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.approval-flow-page {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card-title {
      font-weight: 600;
    }
  }
  .flow-target {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    padding: 14px 16px;
    background: #f7f9fc;
    border-radius: 6px;
    .target-item {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      white-space: nowrap;
      .target-label {
        color: #606266;
        font-size: 13px;
        margin-right: 8px;
        white-space: nowrap;
      }
    }
  }
  .target-alert {
    margin-bottom: 16px;
  }
  .add-row {
    margin-top: 16px;
    text-align: center;
  }
}
</style>
